module.exports = __webpack_public_path__ + "img/product_ecomence_error.6270f8e.png";